<template>
  <!-- Modal -->
  <transition name="modal">
    <div class="modal-mask" @click="$emit('close')">
      <div class="modal-wrapper">
        <div class="modal-container">
          <button type="button" class="close" data-dismiss="modal" @click="$emit('close')">&times;</button>
          <div class="header">
            <h5>Picture</h5>
          </div>
          <div name="body">
            <img v-bind:src="image" class="img" alt="img" />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Modal",
  props: ["image"]
};
</script>

<style>
.modal-mask {
  position: fixed;
  z-index: 1001;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.2s ease;
}



.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 420px;
  margin: 0px auto;
  padding: 10px 10px;
  background-color: steelblue;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.header h5 {
  margin-top: 0;
  color: skyblue;
  text-align: center;
}

.img {
  height: 400px;
  width: 400px;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
@media (min-width: 360px) and (max-width: 640px) {
  .modal-container {
    width: 300px;
  }
  .img {
    height: 220px;
    width: 280px;
  }
}
@media (min-width: 411px) and (max-width: 731px) {
    .modal-container {
    width: 350px;
  }
  .img {
    height: 220px;
    width: 330px;
  }
}
</style>